import { render, staticRenderFns } from "./incidentRelationDialog.vue?vue&type=template&id=97923e7c&scoped=true&"
import script from "./incidentRelationDialog.vue?vue&type=script&lang=js&"
export * from "./incidentRelationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97923e7c",
  null
  
)

export default component.exports